import React, { Component } from 'react';

export default class Video extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className={'video-container'}>
        <video ref="vid" src={this.props.source} autoPlay muted loop />
        <style jsx>{`
          .video-container {
            position: absolute;
            top: -50%;
            left: -50%;
            width: 200%;
            height: 200%;
          }
          .video-container > video {
            position: absolute;
            top: 0;
            bottom: 0;
            right: 0;
            left: 0;
            margin: auto;
            min-height: 50%;
            min-width: 50%;
          }
        `}</style>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/dom-elements/Video.js